module.exports = __webpack_public_path__ + "images/signup/checked.d0faf340.svg";